import React from 'react';

import { IAddress } from '@rbi-ctg/menu';
import { getUSState } from 'utils/restaurant';

import { Address } from './styled';

export const getLocalizedServerOrderStoreAddress = (
  storeAddress: IAddress | undefined,
  formatMessage: Function,
  shouldShowLinebreak: boolean = true
) =>
  formatMessage(
    { id: 'storeAddress' },
    {
      name: '',
      address1: <Address>{storeAddress?.addressLine1 ?? ''}</Address>,
      city: storeAddress?.city ?? '',
      stateProvince: getUSState(storeAddress?.state ?? ''),
      postalCode: storeAddress?.zip ?? '',
      conditionalLinebreak: null,
      linebreak: shouldShowLinebreak ? <br /> : null,
    }
  );

export const getLocalizedStoreAddress = (
  store: any,
  formatMessage: any,
  shouldShowLinebreak: boolean = true
) =>
  formatMessage(
    { id: 'storeAddress' },
    {
      name: '',
      address1: <Address>{store?.physicalAddress?.address1}</Address>,
      city: store?.physicalAddress?.city,
      stateProvince: getUSState(store?.physicalAddress?.stateProvince),
      postalCode: store?.physicalAddress?.postalCode,
      conditionalLinebreak: null,
      linebreak: shouldShowLinebreak ? <br /> : null,
    }
  );

export const getLocalizedDeliveryAddress = (deliveryAddress: any, formatMessage: any) => {
  const addressLine2 = deliveryAddress.addressLine2
    ? formatMessage({ id: 'unitNumber' }, { unitNumber: deliveryAddress.addressLine2 })
    : '';

  return formatMessage(
    { id: 'deliveryAddressFormatted' },
    {
      addressLine1: deliveryAddress.addressLine1,
      addressLine2,
      city: deliveryAddress.city,
      state: deliveryAddress.state,
      zip: deliveryAddress.zip,
      linebreak: <br />,
    }
  );
};

export const getLocalizedDateTime = (formattedPickupDateTime: any, formatMessage: any) =>
  formatMessage(
    { id: 'pickupDateTime' },
    {
      date: formattedPickupDateTime.date,
      time: formattedPickupDateTime.time,
      linebreak: <br />,
    }
  );
